/**
 * PaymentDetailModal.tsx
 *
 * Retired in the Record Payment parity pass. Kept as a thin compatibility
 * re-export so any remaining imports still resolve. The unified
 * `RecordPatientPaymentModal` now handles both "Record Payment" (create) and
 * "Payment Details" (edit) flows, mirroring legacy
 * `html/lib/payment-details-record.php` exactly.
 */
import { RecordPatientPaymentModal } from './RecordPatientPaymentModal';

export interface PaymentDetailModalProps {
  paymentId: number | null;
  patientId: number;
  patientName?: string;
  open: boolean;
  onClose: () => void;
}

export function PaymentDetailModal(props: PaymentDetailModalProps) {
  return (
    <RecordPatientPaymentModal
      patientId={props.patientId}
      patientName={props.patientName}
      paymentId={props.paymentId}
      open={props.open}
      onClose={props.onClose}
      onSaved={() => undefined}
    />
  );
}
